/*
 * @Author: 桓桓
 * @LastEditors: 大梦
 * @Date: 2021-08-30 10:00:00
 * @LastEditTime: 2021-10-19 10:00:00
 */

import Vue from 'vue'


// 挂载基础样式
import 'vant/lib/index.css';
import './assets/css/public.min.css'
import './assets/css/base.less'
import './assets/css/common.less'
import './assets/css/reset.ui.min.less'
import './assets/css/style.min.less'

// vant UI
import Vant from 'vant';
import { Lazyload, Toast, Dialog, Stepper, ActionSheet } from 'vant';
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Stepper);
Vue.use(Lazyload);
Vue.prototype.ToastManager = Toast;
Vue.prototype.AlertManager = Dialog;
Vue.prototype.ActionSheet = ActionSheet;

// 全局配置
import global from './config'
Vue.prototype.GLOBAL = global;
// 接口状态码
Vue.prototype.StatusCode = global.serve;
// 系统常量
Vue.prototype.Constants = global.constant;

// 动画
import animated from 'animate.css'
Vue.use(animated);

// 轻弹窗
import Message from './components/message'
Vue.prototype.Message = Message;

// 状态管理
import store from './store'

// 接口
import API from './api/api';
Vue.prototype.API = API;

// 静态资源 
import Images from './assets/index';
Vue.prototype.Images = Images;
Vue.prototype.IMAGES_DRIVER = global.constant.DRIVER_ALIOSS;


// 已封装请求方法
import { httpPost, httpGet, httpPut, httpDelete, uploadFormData } from './http/axios';
Vue.prototype.$get = httpGet;
Vue.prototype.$post = httpPost;
Vue.prototype.$put = httpPut;
Vue.prototype.$delete = httpDelete;
Vue.prototype.$uploadFormData = uploadFormData;

// 工具
import {
    isWeiXin,
    checkPhone,
    timestampFormat,
} from './utils/tool';
import * as Utils from './utils/tool';
Vue.prototype.Utils = Utils;
Vue.prototype.$isWeiXin = isWeiXin;
Vue.prototype.$checkPhone = checkPhone;
Vue.prototype.timestampFormat = timestampFormat;

// 本地存储
import Lockr from 'lockr'
Vue.prototype.Lockr = Lockr;

// 页面滚动插件
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

// 自定义按钮-带加载状态
import Btn from './components/Btn';
Vue.use(Btn);


// 复制插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// 七牛云上传组件
import {
    QiniuUpload
} from './utils/qiniuUpload'
Vue.prototype.$QiniuUpload = QiniuUpload;



// 查看图片插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var preview_option = {
    showAnimationDuration: 0,
    hideAnimationDuration: 0
}
Vue.use(preview, preview_option);

// vue 挂载
import App from './App.vue'

// 路由加载
import router from './router'

// 多语言
import i18n from './i18n'

// 消息提示的环境配置
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')